import { Styles } from 'jss';

import { StylesDataType } from '../../types';

export const videoStyles: Styles<string, StylesDataType> = {
}
